import fx from 'dojo/_base/fx';

import Mediator from 'gisw/Classes/Mediator';
import { getValue, setValue } from 'gisw/Helpers/storage';

class MessageManager {
  /** @type {Array<HTMLDivElement>} */
  domList = [];

  currentTop = 0;

  /** @type {string} */
  previousMessage = null;

  // Function written for removing the html tags
  // (if any) before logging the messages.
  /**
   * @param {string} str
   */
  stripHTMLTags (str) {
    // Condition for checking if the string is null
    // or empty then return empty string.
    if (str === null || str === '') {
      return '';
    } else {
    }

    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a empty string.
    this.stripHTMLTags = this.stripHTMLTags.bind(this);
    return str.replace(/(<([^>]+)>)/ig, '');
  }

  /**
   * @param {object} msg
   * @param {number} [msg.duration]
   * @param {string} msg.message
   * @param {string} msg.title
   * @param {string} [msg.toolName]
   */
  addMessage (msg) {
    // Ignore repeat messages, unless a tool name is given
    if (this.previousMessage === msg.message && !msg.toolName) {
      return;
    }

    this.previousMessage = msg.message;

    // Limit number of messages on screen
    if (this.domList.length >= 9) {
      return;
    }

    const closeButton = document.createElement('button');
    closeButton.classList.add('close');
    closeButton.textContent = 'X';

    const messageDiv = document.createElement('div');
    messageDiv.classList.add('messageDiv');
    messageDiv.innerHTML = msg.message;

    const titleSpan = document.createElement('span');
    titleSpan.classList.add('title');
    titleSpan.innerHTML = msg.title;

    this.timeout = msg.duration || 10000;
    this.timeout = this.timeout < 1000 ? this.timeout * 1000 : this.timeout;

    const messageContainer = document.createElement('div');

    if (msg.toolName) {
      messageContainer.classList.add('tool-message');
    } else {
      messageContainer.classList.add('message');
    }

    closeButton.addEventListener('click', () => {
      if (msg.toolName) {
        this.toolLeaveScreen(messageContainer);
      } else {
        this.leaveScreen(messageContainer);
      }
    });

    messageContainer.append(titleSpan, closeButton, messageDiv);
    document.getElementById('message-container').appendChild(messageContainer);

    if (msg.toolName) {
      if (getValue('gisw_' + msg.toolName)) {
        if (this.openTool) {
          this.toolLeaveScreen(this.openTool);
        }

        this.openTool = messageContainer;
        return;
      }

      this.addToolNode(messageContainer, msg.toolName);
    } else {
      this.addNode(messageContainer);
    }

    // Code written to send client side
    // javascript errors on the Server for the logging purposes.
    // The logging will be done on the IIS Server
    // which would include the messageTitle
    // entityName (county/city) & errorMessage.
    try {
      if (msg.title === 'Error' || msg.title === 'Warning') {
        const baseUrl = '/MagnumOpus/';
        const entityName = Mediator.serverData.entityName;

        let cleanMessage = '';
        cleanMessage = this.stripHTMLTags(msg.message);

        const errorLoggingUrl = baseUrl + 'messages/'
        + msg.title + '-' + entityName + '-' + cleanMessage + '';
        $.ajax({
          url: errorLoggingUrl,
          type: 'post',
          data: cleanMessage
        });
      }
    } catch (error) {
    }
  }

  /**
   * @param {HTMLDivElement} domNode
   */
  addNode (domNode) {
    const self = this;
    document.getElementById('message-container').appendChild(domNode);
    this.domList.push(domNode);

    fx.animateProperty({
      node: domNode,
      properties: {
        /**
         * @param {HTMLDivElement} node
         */
        right (node) {
          if (window.innerWidth < 599) {
            node.style.height = 'auto;';
            node.style.width = '90%;';
            return -10;
          } else {
            return (
              (node.offsetWidth +
                +node.style.marginLeft +
                +node.style.marginRight) *
              0.15
            );
          }
        },
        /**
         * @param {HTMLDivElement} node
         */
        top (node) {
          if (window.innerWidth < 599) {
            return 60;
          } else {
            const result =
              node.offsetTop + self.domList.length * (node.offsetHeight + 15);

            return result;
          }
        }
      }
    }).play();

    setTimeout(() => {
      this.leaveScreen(domNode);
    }, this.timeout);
  }

  /**
   * @param {HTMLDivElement} domNode
   * @param {string} toolName
   */
  addToolNode (domNode, toolName) {
    if (this.openTool) {
      this.toolLeaveScreen(this.openTool);
    }

    this.openTool = domNode;

    document.getElementById('message-container').appendChild(domNode);

    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.id = 'tool-checkbox';

    const label = document.createElement('label');
    label.htmlFor = 'tool-checkbox';
    label.textContent = 'Do not show this again *';

    const button = document.createElement('button');
    button.type = 'button';
    button.id = 'tool-button';
    button.textContent = 'Got It';

    button.addEventListener('click', () => {
      this.toolLeaveScreen(domNode, toolName);
    });

    const directionsLabel = document.createElement('label');
    directionsLabel.id = 'helpDirections';
    directionsLabel.textContent =
      `*To show hints again, click 'Help' ` + `-> Enable Tool Hints`;

    domNode.append(
      checkbox,
      label,
      document.createElement('br'),
      button,
      document.createElement('br'),
      document.createElement('br'),
      directionsLabel
    );

    fx.animateProperty({
      node: domNode,
      properties: {
        left (node) {
          if (window.innerWidth < 599) {
            node.style.height = 'auto';
            node.style.width = '90%';
            return 15;
          } else {
            const leftPanel = document.getElementById('left-panel');
            return leftPanel.offsetLeft + leftPanel.offsetWidth + 15;
          }
        },
        top (node) {
          if (window.innerWidth < 599) {
            return 15;
          } else {
            const leftPanel = document.getElementById('left-panel');
            return leftPanel.offsetTop;
          }
        }
      }
    }).play();
  }

  leaveScreen (domNode) {
    fx.animateProperty({
      node: domNode,
      duration: 500,
      properties: {
        /**
         * @param {HTMLElement} node
         */
        right (node) {
          return node.offsetWidth * -1.15;
        },
        opacity: 0
      }
    }).play();

    setTimeout(() => {
      const index = this.domList.indexOf(domNode);

      if (index > -1) {
        this.domList.splice(index, 1);

        for (let i = index; i < this.domList.length; i++) {
          shiftUp(this.domList[i]);
        }
      }

      domNode.remove();

      if (this.domList.length === 0) {
        this.previousMessage = null;
      }
    }, 500);
  }

  /**
   * @param {HTMLDivElement} domNode
   * @param {string} toolName
   */
  toolLeaveScreen (domNode = null, toolName = null) {
    // @ts-ignore
    if (toolName && document.getElementById('tool-checkbox')?.checked) {
      Mediator.jstManager.jstToolEvent(
        toolName,
        'Hide Tip - ',
        null,
        null,
        null
      );

      setValue(`gisw_${toolName}`, true);
    }

    if (domNode) {
      domNode.remove();
    } else if (this.openTool) {
      this.openTool.remove();
    }
  }
}

/**
 * @param {HTMLDivElement} domNode
 */
function shiftUp (domNode) {
  const height = domNode.offsetHeight;
  const currentTop = domNode.offsetTop;
  const adjustedHeight = currentTop - height;

  fx.animateProperty({
    node: domNode,
    duration: 500,
    properties: { top: adjustedHeight }
  }).play();
}

export default MessageManager;
